import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Register } from '../../_models/register';
import { Globals } from '../../_models/globals';
import { Router } from '@angular/router';
import { Caller } from '../../_models/caller';
import { User } from '../../_models/user';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { AccessSecurity } from '../../_models/accessSecurity';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
  companyName: string = "";
  email: string = "";
  emailOtp: string = "";
  id: number = null;
  mobileNumber: string = "";
  mobileOtp: string = "";
  password: string = "";
  name: string = "";
  timerDisplayValue: string = "30:00";
  reEnterPassword: string = "";
  errorMessage: string = "";
  successMessage: string = "";
  otpError: string = "";
  otp: string = "";
  confirm: string = "";
  password1: string = "";
  password2: string = "";
  password3: string = "";
  password4: string = "";
  countDown: any = 30;
  interval: any;
  str: any;
  totalDuration: number = 60 * 30;

  constructor(private http: HttpClient, public g: Globals, public accessSec: AccessSecurity, public user: User, private router: Router, public register: Register, public caller: Caller) {

    if (this.register && this.register.registered) {
      this.register.registered = false;
      this.submitResend();
    }
    this.str = (this.user.mobileNumber);
    this.str = this.str ? this.str.toString().replace(/\d(?=\d{3})/g, "*") : this.str;
  }


  ngOnInit() {
    this.startTimer(this.totalDuration);
  }

  resetAccessSecurity() {
    for (let key of Object.keys(this.accessSec)) {
      this.accessSec[key] = false;
    }
  }

  keytab(event, val1, val2) {
    if (event.key == 'Backspace') {
      document.getElementById(val2).focus();
    } else {
      document.getElementById(val1).focus();
    }
  }

  startTimer(duration) {
    let timer = duration, minutes, seconds;
    let timeNew = this.timerDisplayValue;
    this.interval = setInterval(() => {
      minutes = parseInt(timer / 60 + "", 10)
      seconds = parseInt(timer % 60 + "", 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.timerDisplayValue = minutes + ":" + seconds;
      if (--timer < 0) {
        timer = duration;
      }
      //console.log(this.timerDisplayValue);
      //console.log(timerNew);
    }, 1000);
    //console.log(timerNew);
  }

  stopTimerFunction() {
    clearInterval(this.interval);
    this.timerDisplayValue = "30:00";
  }

  verifyOtp() {
    this.otp = this.password1.toString() + this.password2.toString() + this.password3.toString() + this.password4.toString();
    this.successMessage = "";
    this.errorMessage = "";
    if (!this.otp) {
      this.errorMessage = "Please Enter OTP";
    }
    if (this.errorMessage != "") {
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/validateOtp', {
      "mobileNumber": this.caller.parent == "REGISTER" ? this.register.getMobile() : this.user.mobileNumber,
      "otp": this.otp
    },
      { headers: header1 }
    ).subscribe(data => {
      if (data['code'] == 200) {
        this.successMessage = "OTP Created Successfully";
        //this.submitRegistration();
        //this.router.navigate(['/access/warehouseRequest']);
        if (this.caller.parent == "REGISTER") {
          this.router.navigate(['/access/info']);
        } else if (this.caller.parent == "TWO_VERIFICATION") {
          if (this.user.role == 'ROLE_ADMIN') {
            this.router.navigate(['/admin/adminDashboard']);
          } else if (this.user.role == 'ACCOUNT_OWNER') {
            this.router.navigate(['/admin/dashboard']);
          } else if (this.user.role == 'AO_SELLER') {
            this.router.navigate(['/admin/sellerOrdersList']);
          } else if (this.user.role == 'DEMO_ACCOUNT') {
            this.router.navigate(['/admin/dashboard']);
          } else if (this.user.role == 'DRIVER') {
            this.router.navigate(['/admin/driverDashboard']);
          } else if (this.user.role == 'WORK_MEN' || this.user.role == 'PACKER') {
            this.router.navigate(['/admin/workMenOrder']);
          } else if (this.user.role == 'RECEIVER' || this.user.role == 'SECURITY') {
            this.router.navigate(['/admin/securityDefault']);
          } else if (this.user.role == 'CUSTOMER_CARE' || this.user.role == 'SALES_MKTG') {
            this.router.navigate(['/admin/customercareOrders']);
          } else if (this.user.role == 'FINANCE') {
            this.router.navigate(['/admin/financeCODOrdersList']);
          } else {
            if (this.accessSec.viewDashboard) {
              this.router.navigate(['/admin/dashboard']);
            } else {
              this.router.navigate(['/admin/myAccountList']);
            }
          }
        }
      } else {
        this.errorMessage = data['message'];
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.errorMessage = "otp Failed, please re-try.";
      }
    )
  }

  submitRegistration() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/registerCompany', {
      "companyName": this.register.companyName,
      "email": this.register.email,
      "mobileNumber": this.register.mobile,
      "organizationId": 1,
      "name": this.register.name,
      "password": this.register.password,
      "reEnterPassword": this.register.reEnterPassword
    },
      { headers: header1 }).subscribe(data => {
        this.router.navigate(['/access/warehouseRequest']);
        this.register.Id = data['id'];
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.errorMessage = "Registration Failed, please re-try.";
        }
      )
  }

  submitResend() {
    this.stopTimerFunction();
    this.successMessage = "";
    this.errorMessage = "";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.password1 = "";
    this.password2 = "";
    this.password3 = "";
    this.password4 = "";
    this.http.post(environment.apiUrl + 'api/generateOTP?mobileNumber=' + this.user.mobileNumber + "&organizationId=" + this.user.organizationId,
      {
        headers: header1
      }).subscribe(data => {
        if (data['code'] == 200) {
          this.successMessage = data['message'];
          this.startTimer(this.totalDuration);
        } else {
          this.errorMessage = "invalid otp";
          if (data['code'] == 400) {
            this.errorMessage = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.errorMessage = "Failed OTP Generation, please retry.";
        }
      );
  }

  verifyFPOtp() {
    this.successMessage = "";
    this.errorMessage = "";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.otp = this.password1 + this.password2 + this.password3 + this.password4;
    this.http.post(environment.apiUrl + 'api/validateOTPForResetPwd', {
      "mobileNumber": this.register.mobile,
      "otp": this.otp
    },
      { headers: header1 }
    ).subscribe((data: any) => {
      if (data['code'] == 200) {
        this.successMessage = "OTP Created Successfully";
        this.router.navigate(['/access/resetpassword/' + data.token]);
      } else {
        this.errorMessage = "Invalid OTP";
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.errorMessage = "otp Failed, please re-try.";
      }
    )
  }

}
